import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { api } from 'api';
import { valuteToApi } from 'libs/common';
import { Button, themes } from 'libs/ui';
import { NewTicket } from '../forms/new-ticket';

export const NewTicketAction = (props) => {
  const { withoutInfo, refresh } = props;
  const info = withoutInfo
    ? {
        parking_id: 0,
        id: 0,
        is_active: true,
        stay_zones: null,
      }
    : useSelector((state) => state.stays.stay);
  const [show, setShow] = useState(false);
  const { parking_id, id, is_active, stay_zones } = info;

  const { t } = useTranslation();

  /**
   * show form
   */
  const showForm = () => {
    setShow(true);
  };

  /**
   * hide form
   */
  const hideForm = () => {
    setShow(false);
  };

  /**
   * change mean status
   */
  const action = (data) => {
    // console.log('🚀 ~ action ~ data:', data);
    const { parkomat, value, comment, zone, vehicle_plate } = data;
    const params = {
      stay_id: typeof id === 'string' ? id : null,
      payment_rack_id: parkomat,
      penalty: valuteToApi(value),
      comment: value ? comment : '',
    };
    if (zone) {
      params.zone_id = zone;
    }
    if (vehicle_plate) {
      params.vehicle_plate = vehicle_plate;
    }
    const withParkingId = window.config.central ? parking_id : '';

    return api.call('stays.print_receipt', params, 'NetworkManager', withParkingId ? '/' + parking_id : '').then(() => {
      refresh();
    });
  };

  // check
  if (!is_active || !user.haveRight('stays.print_receipt')) {
    return null;
  }

  return (
    <>
      {show && <NewTicket id={id} parkingId={parking_id} close={hideForm} action={action} withoutInfo={withoutInfo} stayZones={stay_zones} />}

      <Button theme={themes.blue} fontSize="16px" onClick={showForm}>
        <i className="fa fa-ticket"></i>
        {t('buttons.Новый билет')}
      </Button>{' '}
    </>
  );
};

NewTicketAction.propTypes = {
  withoutInfo: PropTypes.bool,
};
